import React from 'react';

export const ZeplinSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-19.5"
				y="-550.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
				fill="white"
			/>
			<path
				d="M0.513685 8C0.513685 3.86542 3.86542 0.513685 8 0.513685H24C28.1346 0.513685 31.4863 3.86542 31.4863 8V24C31.4863 28.1346 28.1346 31.4863 24 31.4863H8C3.86542 31.4863 0.513685 28.1346 0.513685 24V8Z"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="1.02737"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.69901 19.4429L6.44342 19.886L6.37622 23.4935L10.7222 21.9604C9.2314 21.4767 8.14301 20.6255 7.69901 19.4429Z"
				fill="#FDBD39"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.35597 15.6271L4 17.164L6.44398 19.8859L7.69917 19.4428C7.25638 18.2636 7.52918 16.931 8.35597 15.6271Z"
				fill="#F69833"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.6872 10.4215C10.1396 12.3788 6.56324 16.4178 7.69923 19.443L27.7875 12.3549C26.6515 9.32966 21.2343 8.46421 15.6872 10.4215Z"
				fill="#FECF33"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.7998 21.3764C25.347 19.4187 28.9298 15.3978 27.7878 12.3549L7.69873 19.443C8.84112 22.486 14.2523 23.3337 19.7998 21.3764Z"
				fill="#EE6723"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M27.7878 12.3549L7.69873 19.443C8.09193 20.4908 9.59232 21.007 11.6967 21.007C13.7487 21.007 16.3755 20.5167 19.1138 19.5504C24.661 17.5931 28.5638 14.4238 27.787 12.3549"
				fill="#F69833"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.7894 10.7908C21.7374 10.7908 19.1106 11.2811 16.3722 12.2474C10.8251 14.2047 6.92231 17.3736 7.6991 19.4429L27.7874 12.3548C27.3942 11.3069 25.8942 10.7908 23.7894 10.7908Z"
				fill="#FDBD39"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.6798 23.685C22.0886 23.685 21.217 23.1692 20.0878 22.1523C18.753 20.9492 17.2234 19.187 15.7811 17.1899C14.3391 15.1936 13.1539 13.1973 12.4443 11.5691C11.6715 9.79497 11.5611 8.70428 12.1167 8.3268C12.2387 8.24412 12.3855 8.20239 12.5535 8.20239C13.0055 8.20239 13.8863 8.52732 15.5147 10.0762L15.5507 10.1099L15.5455 10.1582C15.5343 10.2694 15.5243 10.3819 15.5151 10.492L15.4971 10.7106L15.3371 10.5553C13.5823 8.84762 12.8099 8.66332 12.5591 8.66332C12.4875 8.66332 12.4307 8.67723 12.3899 8.70505C12.1487 8.86848 12.1331 9.66979 12.8827 11.3895C13.5799 12.9886 14.7475 14.9544 16.1707 16.9253C17.5946 18.8965 19.1006 20.6328 20.4122 21.8143C21.8262 23.0885 22.4634 23.226 22.6722 23.226C22.7442 23.226 22.8022 23.2114 22.8458 23.1816C23.0998 23.0093 23.1002 22.1508 22.2642 20.2994L22.2258 20.2147L22.3098 20.1703C22.3938 20.1259 22.4754 20.0822 22.5514 20.0405L22.6522 19.9852L22.6986 20.0876C23.291 21.3993 23.845 23.0665 23.1186 23.5599C22.9962 23.6429 22.8486 23.685 22.6798 23.685Z"
				fill="#EE6723"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.9342 21.3212L19.9262 21.4216C19.7858 23.098 19.4162 25.1129 18.4534 25.1948C18.4342 25.1964 18.4142 25.1971 18.3942 25.1971C17.7398 25.1971 17.121 24.2919 16.555 22.5069C16.019 20.8177 15.603 18.5506 15.3842 16.1215C15.1651 13.6936 15.1683 11.3901 15.3934 9.63644C15.6386 7.72511 16.1058 6.72714 16.7818 6.66957C16.8018 6.66803 16.8226 6.66687 16.843 6.66687C17.3174 6.66687 18.0326 7.18614 18.7646 9.60321L18.2866 9.69208C18.0422 8.88458 17.7758 8.22777 17.5114 7.77573C17.2666 7.35846 17.029 7.12857 16.8418 7.12857C16.8354 7.12857 16.8294 7.12857 16.823 7.12934C16.5302 7.15407 16.1034 7.84063 15.8658 9.69324C15.6446 11.4156 15.6418 13.6843 15.8578 16.0813C16.0746 18.4787 16.4834 20.7126 17.0098 22.3713C17.2454 23.1139 17.5038 23.7263 17.7574 24.1416C17.991 24.5249 18.217 24.7358 18.3938 24.7358C18.3998 24.7358 18.4058 24.7358 18.4122 24.735C18.6922 24.7115 19.2206 23.9971 19.443 21.4838L19.9342 21.3212Z"
				fill="#EE6723"
			/>
		</svg>
	);
};
